/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { Route as rootRouteImport } from './routes/__root';
import { Route as LayoutRouteImport } from './routes/_layout';
import { Route as LayoutIndexRouteImport } from './routes/_layout/index';
import { Route as ConsoleAuthenticatedRouteImport } from './routes/console/_authenticated';
import { Route as LayoutAboutAdoraMediaIndexRouteImport } from './routes/_layout/about-adora-media/index';
import { Route as LayoutBlogIndexRouteImport } from './routes/_layout/blog/index';
import { Route as LayoutCaseStudiesIndexRouteImport } from './routes/_layout/case-studies/index';
import { Route as LayoutCompareIndexRouteImport } from './routes/_layout/compare/index';
import { Route as LayoutDataDeletionIndexRouteImport } from './routes/_layout/data-deletion/index';
import { Route as LayoutFaqIndexRouteImport } from './routes/_layout/faq/index';
import { Route as LayoutFeaturesIndexRouteImport } from './routes/_layout/features/index';
import { Route as LayoutForgotPasswordIndexRouteImport } from './routes/_layout/forgot-password/index';
import { Route as LayoutHowItWorksIndexRouteImport } from './routes/_layout/how-it-works/index';
import { Route as LayoutLearnIndexRouteImport } from './routes/_layout/learn/index';
import { Route as LayoutLinkErrorIndexRouteImport } from './routes/_layout/link-error/index';
import { Route as LayoutPoweredByAdoraIndexRouteImport } from './routes/_layout/powered-by-adora/index';
import { Route as LayoutPricingIndexRouteImport } from './routes/_layout/pricing/index';
import { Route as LayoutPrivacyIndexRouteImport } from './routes/_layout/privacy/index';
import { Route as LayoutQrBuilderIndexRouteImport } from './routes/_layout/qr-builder/index';
import { Route as LayoutSignInIndexRouteImport } from './routes/_layout/sign-in/index';
import { Route as LayoutSignUpIndexRouteImport } from './routes/_layout/sign-up/index';
import { Route as LayoutSmartLinkIndexRouteImport } from './routes/_layout/smart-link/index';
import { Route as LayoutStatusIndexRouteImport } from './routes/_layout/status/index';
import { Route as LayoutTermsIndexRouteImport } from './routes/_layout/terms/index';
import { Route as LayoutWhatIsAdoraIndexRouteImport } from './routes/_layout/what-is-adora/index';
import { Route as AuthCallbackIndexRouteImport } from './routes/auth/callback/index';
import { Route as ConsoleAuthenticatedLayoutRouteImport } from './routes/console/_authenticated/_layout';
import { Route as LayoutBlogFeedbackCampaignsIndexRouteImport } from './routes/_layout/blog/feedback-campaigns/index';
import { Route as LayoutBlogNfcSmartLinkIndexRouteImport } from './routes/_layout/blog/nfc-smart-link/index';
import { Route as LayoutBlogPageDesignThemesIndexRouteImport } from './routes/_layout/blog/page-design-themes/index';
import { Route as LayoutBlogQrBestPracticesIndexRouteImport } from './routes/_layout/blog/qr-best-practices/index';
import { Route as LayoutBlogTelegramBotSetupIndexRouteImport } from './routes/_layout/blog/telegram-bot-setup/index';
import { Route as LayoutBlogTelegramNotificationsIndexRouteImport } from './routes/_layout/blog/telegram-notifications/index';
import { Route as LayoutCaseStudiesBeefAndBasilIndexRouteImport } from './routes/_layout/case-studies/beef-and-basil/index';
import { Route as LayoutCompareFlowcodeIndexRouteImport } from './routes/_layout/compare/flowcode/index';
import { Route as LayoutCompareHeylinkIndexRouteImport } from './routes/_layout/compare/heylink/index';
import { Route as LayoutCompareLinktreeIndexRouteImport } from './routes/_layout/compare/linktree/index';
import { Route as LayoutLearnOfflineMarketingAnalyticsIndexRouteImport } from './routes/_layout/learn/offline-marketing-analytics/index';
import { Route as LayoutLearnOneLinkEngineIndexRouteImport } from './routes/_layout/learn/one-link-engine/index';
import { Route as LayoutLearnQrScanTrackingIndexRouteImport } from './routes/_layout/learn/qr-scan-tracking/index';
import { Route as LayoutLearnSmartLinksVsLinkInBioIndexRouteImport } from './routes/_layout/learn/smart-links-vs-link-in-bio/index';
import { Route as LayoutLearnSmartLinksIndexRouteImport } from './routes/_layout/learn/smart-links/index';
import { Route as AuthLinkConsumesTokenRouteImport } from './routes/auth/link/consumes/$token';
import { Route as ConsoleAuthenticatedLayoutIndexRouteImport } from './routes/console/_authenticated/_layout/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsNewRouteImport } from './routes/console/_authenticated/_layout/campaigns/new';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutRouteImport } from './routes/console/_authenticated/_layout/internal/_layout';
import { Route as ConsoleAuthenticatedLayoutOnboardingIndexRouteImport } from './routes/console/_authenticated/_layout/onboarding/index';
import { Route as ConsoleAuthenticatedLayoutProfileLayoutRouteImport } from './routes/console/_authenticated/_layout/profile/_layout';
import { Route as ConsoleAuthenticatedLayoutWorkspaceLayoutRouteImport } from './routes/console/_authenticated/_layout/workspace/_layout';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/index';
import { Route as ConsoleAuthenticatedLayoutProfileLayoutIndexRouteImport } from './routes/console/_authenticated/_layout/profile/_layout/index';
import { Route as ConsoleAuthenticatedLayoutWorkspaceLayoutIndexRouteImport } from './routes/console/_authenticated/_layout/workspace/_layout/index';
import { Route as ConsoleAuthenticatedLayoutWorkspaceLayoutBillingRouteImport } from './routes/console/_authenticated/_layout/workspace/_layout/billing';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutAssignmentsIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/assignments/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutAssignmentsPublicIdRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/assignments/$publicId';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutAssignmentsNewRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/assignments/new';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutCronIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/cron/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutDriversIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/drivers/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutDriversPublicIdRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/drivers/$publicId';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutDriversNewRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/drivers/new';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutPayoutsIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/payouts/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutPayoutsPublicIdRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/payouts/$publicId';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutPhotosIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/photos/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutPhotosNewRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/photos/new';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutSettingsIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/settings/index';
import { Route as ConsoleAuthenticatedLayoutInternalLayoutTeamIndexRouteImport } from './routes/console/_authenticated/_layout/internal/_layout/team/index';
import { Route as ConsoleAuthenticatedLayoutProfileLayoutConnectionsIndexRouteImport } from './routes/console/_authenticated/_layout/profile/_layout/connections/index';
import { Route as ConsoleAuthenticatedLayoutProfileLayoutSecurityIndexRouteImport } from './routes/console/_authenticated/_layout/profile/_layout/security/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAnalyticsIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/analytics/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutCustomizeIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/customize/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutFeedbackIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/feedback/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutDestinationsIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/destinations/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksByDestinationIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/smart-links-by-destination/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/smart-links/index';
import { Route as ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutThemesIndexRouteImport } from './routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/themes/index';
const LayoutRoute = LayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => rootRouteImport,
});
const LayoutIndexRoute = LayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutRoute,
});
const ConsoleAuthenticatedRoute = ConsoleAuthenticatedRouteImport.update({
    id: '/console/_authenticated',
    path: '/console',
    getParentRoute: () => rootRouteImport,
});
const LayoutAboutAdoraMediaIndexRoute = LayoutAboutAdoraMediaIndexRouteImport.update({
    id: '/about-adora-media/',
    path: '/about-adora-media/',
    getParentRoute: () => LayoutRoute,
});
const LayoutBlogIndexRoute = LayoutBlogIndexRouteImport.update({
    id: '/blog/',
    path: '/blog/',
    getParentRoute: () => LayoutRoute,
});
const LayoutCaseStudiesIndexRoute = LayoutCaseStudiesIndexRouteImport.update({
    id: '/case-studies/',
    path: '/case-studies/',
    getParentRoute: () => LayoutRoute,
});
const LayoutCompareIndexRoute = LayoutCompareIndexRouteImport.update({
    id: '/compare/',
    path: '/compare/',
    getParentRoute: () => LayoutRoute,
});
const LayoutDataDeletionIndexRoute = LayoutDataDeletionIndexRouteImport.update({
    id: '/data-deletion/',
    path: '/data-deletion/',
    getParentRoute: () => LayoutRoute,
});
const LayoutFaqIndexRoute = LayoutFaqIndexRouteImport.update({
    id: '/faq/',
    path: '/faq/',
    getParentRoute: () => LayoutRoute,
});
const LayoutFeaturesIndexRoute = LayoutFeaturesIndexRouteImport.update({
    id: '/features/',
    path: '/features/',
    getParentRoute: () => LayoutRoute,
});
const LayoutForgotPasswordIndexRoute = LayoutForgotPasswordIndexRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => LayoutRoute,
});
const LayoutHowItWorksIndexRoute = LayoutHowItWorksIndexRouteImport.update({
    id: '/how-it-works/',
    path: '/how-it-works/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLearnIndexRoute = LayoutLearnIndexRouteImport.update({
    id: '/learn/',
    path: '/learn/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLinkErrorIndexRoute = LayoutLinkErrorIndexRouteImport.update({
    id: '/link-error/',
    path: '/link-error/',
    getParentRoute: () => LayoutRoute,
});
const LayoutPoweredByAdoraIndexRoute = LayoutPoweredByAdoraIndexRouteImport.update({
    id: '/powered-by-adora/',
    path: '/powered-by-adora/',
    getParentRoute: () => LayoutRoute,
});
const LayoutPricingIndexRoute = LayoutPricingIndexRouteImport.update({
    id: '/pricing/',
    path: '/pricing/',
    getParentRoute: () => LayoutRoute,
});
const LayoutPrivacyIndexRoute = LayoutPrivacyIndexRouteImport.update({
    id: '/privacy/',
    path: '/privacy/',
    getParentRoute: () => LayoutRoute,
});
const LayoutQrBuilderIndexRoute = LayoutQrBuilderIndexRouteImport.update({
    id: '/qr-builder/',
    path: '/qr-builder/',
    getParentRoute: () => LayoutRoute,
});
const LayoutSignInIndexRoute = LayoutSignInIndexRouteImport.update({
    id: '/sign-in/',
    path: '/sign-in/',
    getParentRoute: () => LayoutRoute,
});
const LayoutSignUpIndexRoute = LayoutSignUpIndexRouteImport.update({
    id: '/sign-up/',
    path: '/sign-up/',
    getParentRoute: () => LayoutRoute,
});
const LayoutSmartLinkIndexRoute = LayoutSmartLinkIndexRouteImport.update({
    id: '/smart-link/',
    path: '/smart-link/',
    getParentRoute: () => LayoutRoute,
});
const LayoutStatusIndexRoute = LayoutStatusIndexRouteImport.update({
    id: '/status/',
    path: '/status/',
    getParentRoute: () => LayoutRoute,
});
const LayoutTermsIndexRoute = LayoutTermsIndexRouteImport.update({
    id: '/terms/',
    path: '/terms/',
    getParentRoute: () => LayoutRoute,
});
const LayoutWhatIsAdoraIndexRoute = LayoutWhatIsAdoraIndexRouteImport.update({
    id: '/what-is-adora/',
    path: '/what-is-adora/',
    getParentRoute: () => LayoutRoute,
});
const AuthCallbackIndexRoute = AuthCallbackIndexRouteImport.update({
    id: '/auth/callback/',
    path: '/auth/callback/',
    getParentRoute: () => rootRouteImport,
});
const ConsoleAuthenticatedLayoutRoute = ConsoleAuthenticatedLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => ConsoleAuthenticatedRoute,
});
const LayoutBlogFeedbackCampaignsIndexRoute = LayoutBlogFeedbackCampaignsIndexRouteImport.update({
    id: '/blog/feedback-campaigns/',
    path: '/blog/feedback-campaigns/',
    getParentRoute: () => LayoutRoute,
});
const LayoutBlogNfcSmartLinkIndexRoute = LayoutBlogNfcSmartLinkIndexRouteImport.update({
    id: '/blog/nfc-smart-link/',
    path: '/blog/nfc-smart-link/',
    getParentRoute: () => LayoutRoute,
});
const LayoutBlogPageDesignThemesIndexRoute = LayoutBlogPageDesignThemesIndexRouteImport.update({
    id: '/blog/page-design-themes/',
    path: '/blog/page-design-themes/',
    getParentRoute: () => LayoutRoute,
});
const LayoutBlogQrBestPracticesIndexRoute = LayoutBlogQrBestPracticesIndexRouteImport.update({
    id: '/blog/qr-best-practices/',
    path: '/blog/qr-best-practices/',
    getParentRoute: () => LayoutRoute,
});
const LayoutBlogTelegramBotSetupIndexRoute = LayoutBlogTelegramBotSetupIndexRouteImport.update({
    id: '/blog/telegram-bot-setup/',
    path: '/blog/telegram-bot-setup/',
    getParentRoute: () => LayoutRoute,
});
const LayoutBlogTelegramNotificationsIndexRoute = LayoutBlogTelegramNotificationsIndexRouteImport.update({
    id: '/blog/telegram-notifications/',
    path: '/blog/telegram-notifications/',
    getParentRoute: () => LayoutRoute,
});
const LayoutCaseStudiesBeefAndBasilIndexRoute = LayoutCaseStudiesBeefAndBasilIndexRouteImport.update({
    id: '/case-studies/beef-and-basil/',
    path: '/case-studies/beef-and-basil/',
    getParentRoute: () => LayoutRoute,
});
const LayoutCompareFlowcodeIndexRoute = LayoutCompareFlowcodeIndexRouteImport.update({
    id: '/compare/flowcode/',
    path: '/compare/flowcode/',
    getParentRoute: () => LayoutRoute,
});
const LayoutCompareHeylinkIndexRoute = LayoutCompareHeylinkIndexRouteImport.update({
    id: '/compare/heylink/',
    path: '/compare/heylink/',
    getParentRoute: () => LayoutRoute,
});
const LayoutCompareLinktreeIndexRoute = LayoutCompareLinktreeIndexRouteImport.update({
    id: '/compare/linktree/',
    path: '/compare/linktree/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLearnOfflineMarketingAnalyticsIndexRoute = LayoutLearnOfflineMarketingAnalyticsIndexRouteImport.update({
    id: '/learn/offline-marketing-analytics/',
    path: '/learn/offline-marketing-analytics/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLearnOneLinkEngineIndexRoute = LayoutLearnOneLinkEngineIndexRouteImport.update({
    id: '/learn/one-link-engine/',
    path: '/learn/one-link-engine/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLearnQrScanTrackingIndexRoute = LayoutLearnQrScanTrackingIndexRouteImport.update({
    id: '/learn/qr-scan-tracking/',
    path: '/learn/qr-scan-tracking/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLearnSmartLinksVsLinkInBioIndexRoute = LayoutLearnSmartLinksVsLinkInBioIndexRouteImport.update({
    id: '/learn/smart-links-vs-link-in-bio/',
    path: '/learn/smart-links-vs-link-in-bio/',
    getParentRoute: () => LayoutRoute,
});
const LayoutLearnSmartLinksIndexRoute = LayoutLearnSmartLinksIndexRouteImport.update({
    id: '/learn/smart-links/',
    path: '/learn/smart-links/',
    getParentRoute: () => LayoutRoute,
});
const AuthLinkConsumesTokenRoute = AuthLinkConsumesTokenRouteImport.update({
    id: '/auth/link/consumes/$token',
    path: '/auth/link/consumes/$token',
    getParentRoute: () => rootRouteImport,
});
const ConsoleAuthenticatedLayoutIndexRoute = ConsoleAuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsIndexRoute = ConsoleAuthenticatedLayoutCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsNewRoute = ConsoleAuthenticatedLayoutCampaignsNewRouteImport.update({
    id: '/campaigns/new',
    path: '/campaigns/new',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutRoute = ConsoleAuthenticatedLayoutInternalLayoutRouteImport.update({
    id: '/internal/_layout',
    path: '/internal',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutOnboardingIndexRoute = ConsoleAuthenticatedLayoutOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutProfileLayoutRoute = ConsoleAuthenticatedLayoutProfileLayoutRouteImport.update({
    id: '/profile/_layout',
    path: '/profile',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutWorkspaceLayoutRoute = ConsoleAuthenticatedLayoutWorkspaceLayoutRouteImport.update({
    id: '/workspace/_layout',
    path: '/workspace',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRouteImport.update({
    id: '/campaigns/$publicId/_layout',
    path: '/campaigns/$publicId',
    getParentRoute: () => ConsoleAuthenticatedLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutProfileLayoutIndexRoute = ConsoleAuthenticatedLayoutProfileLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleAuthenticatedLayoutProfileLayoutRoute,
});
const ConsoleAuthenticatedLayoutWorkspaceLayoutIndexRoute = ConsoleAuthenticatedLayoutWorkspaceLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleAuthenticatedLayoutWorkspaceLayoutRoute,
});
const ConsoleAuthenticatedLayoutWorkspaceLayoutBillingRoute = ConsoleAuthenticatedLayoutWorkspaceLayoutBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => ConsoleAuthenticatedLayoutWorkspaceLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutAssignmentsIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutAssignmentsIndexRouteImport.update({
    id: '/assignments/',
    path: '/assignments/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutAssignmentsPublicIdRoute = ConsoleAuthenticatedLayoutInternalLayoutAssignmentsPublicIdRouteImport.update({
    id: '/assignments/$publicId',
    path: '/assignments/$publicId',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutAssignmentsNewRoute = ConsoleAuthenticatedLayoutInternalLayoutAssignmentsNewRouteImport.update({
    id: '/assignments/new',
    path: '/assignments/new',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutCronIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutCronIndexRouteImport.update({
    id: '/cron/',
    path: '/cron/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutDriversIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutDriversIndexRouteImport.update({
    id: '/drivers/',
    path: '/drivers/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutDriversPublicIdRoute = ConsoleAuthenticatedLayoutInternalLayoutDriversPublicIdRouteImport.update({
    id: '/drivers/$publicId',
    path: '/drivers/$publicId',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutDriversNewRoute = ConsoleAuthenticatedLayoutInternalLayoutDriversNewRouteImport.update({
    id: '/drivers/new',
    path: '/drivers/new',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutPayoutsIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutPayoutsIndexRouteImport.update({
    id: '/payouts/',
    path: '/payouts/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutPayoutsPublicIdRoute = ConsoleAuthenticatedLayoutInternalLayoutPayoutsPublicIdRouteImport.update({
    id: '/payouts/$publicId',
    path: '/payouts/$publicId',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutPhotosIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutPhotosIndexRouteImport.update({
    id: '/photos/',
    path: '/photos/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutPhotosNewRoute = ConsoleAuthenticatedLayoutInternalLayoutPhotosNewRouteImport.update({
    id: '/photos/new',
    path: '/photos/new',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutSettingsIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutInternalLayoutTeamIndexRoute = ConsoleAuthenticatedLayoutInternalLayoutTeamIndexRouteImport.update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => ConsoleAuthenticatedLayoutInternalLayoutRoute,
});
const ConsoleAuthenticatedLayoutProfileLayoutConnectionsIndexRoute = ConsoleAuthenticatedLayoutProfileLayoutConnectionsIndexRouteImport.update({
    id: '/connections/',
    path: '/connections/',
    getParentRoute: () => ConsoleAuthenticatedLayoutProfileLayoutRoute,
});
const ConsoleAuthenticatedLayoutProfileLayoutSecurityIndexRoute = ConsoleAuthenticatedLayoutProfileLayoutSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => ConsoleAuthenticatedLayoutProfileLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRouteImport.update({
    id: '/ab-testing/_layout',
    path: '/ab-testing',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAnalyticsIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutCustomizeIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutCustomizeIndexRouteImport.update({
    id: '/customize/',
    path: '/customize/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutFeedbackIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutFeedbackIndexRouteImport.update({
    id: '/feedback/',
    path: '/feedback/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutDestinationsIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutDestinationsIndexRouteImport.update({
    id: '/destinations/',
    path: '/destinations/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksByDestinationIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksByDestinationIndexRouteImport.update({
    id: '/smart-links-by-destination/',
    path: '/smart-links-by-destination/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksIndexRouteImport.update({
    id: '/smart-links/',
    path: '/smart-links/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute,
});
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutThemesIndexRoute = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutThemesIndexRouteImport.update({
    id: '/themes/',
    path: '/themes/',
    getParentRoute: () => ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute,
});
const LayoutRouteChildren = {
    LayoutIndexRoute: LayoutIndexRoute,
    LayoutAboutAdoraMediaIndexRoute: LayoutAboutAdoraMediaIndexRoute,
    LayoutBlogIndexRoute: LayoutBlogIndexRoute,
    LayoutCaseStudiesIndexRoute: LayoutCaseStudiesIndexRoute,
    LayoutCompareIndexRoute: LayoutCompareIndexRoute,
    LayoutDataDeletionIndexRoute: LayoutDataDeletionIndexRoute,
    LayoutFaqIndexRoute: LayoutFaqIndexRoute,
    LayoutFeaturesIndexRoute: LayoutFeaturesIndexRoute,
    LayoutForgotPasswordIndexRoute: LayoutForgotPasswordIndexRoute,
    LayoutHowItWorksIndexRoute: LayoutHowItWorksIndexRoute,
    LayoutLearnIndexRoute: LayoutLearnIndexRoute,
    LayoutLinkErrorIndexRoute: LayoutLinkErrorIndexRoute,
    LayoutPoweredByAdoraIndexRoute: LayoutPoweredByAdoraIndexRoute,
    LayoutPricingIndexRoute: LayoutPricingIndexRoute,
    LayoutPrivacyIndexRoute: LayoutPrivacyIndexRoute,
    LayoutQrBuilderIndexRoute: LayoutQrBuilderIndexRoute,
    LayoutSignInIndexRoute: LayoutSignInIndexRoute,
    LayoutSignUpIndexRoute: LayoutSignUpIndexRoute,
    LayoutSmartLinkIndexRoute: LayoutSmartLinkIndexRoute,
    LayoutStatusIndexRoute: LayoutStatusIndexRoute,
    LayoutTermsIndexRoute: LayoutTermsIndexRoute,
    LayoutWhatIsAdoraIndexRoute: LayoutWhatIsAdoraIndexRoute,
    LayoutBlogFeedbackCampaignsIndexRoute: LayoutBlogFeedbackCampaignsIndexRoute,
    LayoutBlogNfcSmartLinkIndexRoute: LayoutBlogNfcSmartLinkIndexRoute,
    LayoutBlogPageDesignThemesIndexRoute: LayoutBlogPageDesignThemesIndexRoute,
    LayoutBlogQrBestPracticesIndexRoute: LayoutBlogQrBestPracticesIndexRoute,
    LayoutBlogTelegramBotSetupIndexRoute: LayoutBlogTelegramBotSetupIndexRoute,
    LayoutBlogTelegramNotificationsIndexRoute: LayoutBlogTelegramNotificationsIndexRoute,
    LayoutCaseStudiesBeefAndBasilIndexRoute: LayoutCaseStudiesBeefAndBasilIndexRoute,
    LayoutCompareFlowcodeIndexRoute: LayoutCompareFlowcodeIndexRoute,
    LayoutCompareHeylinkIndexRoute: LayoutCompareHeylinkIndexRoute,
    LayoutCompareLinktreeIndexRoute: LayoutCompareLinktreeIndexRoute,
    LayoutLearnOfflineMarketingAnalyticsIndexRoute: LayoutLearnOfflineMarketingAnalyticsIndexRoute,
    LayoutLearnOneLinkEngineIndexRoute: LayoutLearnOneLinkEngineIndexRoute,
    LayoutLearnQrScanTrackingIndexRoute: LayoutLearnQrScanTrackingIndexRoute,
    LayoutLearnSmartLinksVsLinkInBioIndexRoute: LayoutLearnSmartLinksVsLinkInBioIndexRoute,
    LayoutLearnSmartLinksIndexRoute: LayoutLearnSmartLinksIndexRoute,
};
const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren);
const ConsoleAuthenticatedLayoutInternalLayoutRouteChildren = {
    ConsoleAuthenticatedLayoutInternalLayoutIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutAssignmentsPublicIdRoute: ConsoleAuthenticatedLayoutInternalLayoutAssignmentsPublicIdRoute,
    ConsoleAuthenticatedLayoutInternalLayoutAssignmentsNewRoute: ConsoleAuthenticatedLayoutInternalLayoutAssignmentsNewRoute,
    ConsoleAuthenticatedLayoutInternalLayoutDriversPublicIdRoute: ConsoleAuthenticatedLayoutInternalLayoutDriversPublicIdRoute,
    ConsoleAuthenticatedLayoutInternalLayoutDriversNewRoute: ConsoleAuthenticatedLayoutInternalLayoutDriversNewRoute,
    ConsoleAuthenticatedLayoutInternalLayoutPayoutsPublicIdRoute: ConsoleAuthenticatedLayoutInternalLayoutPayoutsPublicIdRoute,
    ConsoleAuthenticatedLayoutInternalLayoutPhotosNewRoute: ConsoleAuthenticatedLayoutInternalLayoutPhotosNewRoute,
    ConsoleAuthenticatedLayoutInternalLayoutAssignmentsIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutAssignmentsIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutCronIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutCronIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutDriversIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutDriversIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutPayoutsIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutPayoutsIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutPhotosIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutPhotosIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutSettingsIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutSettingsIndexRoute,
    ConsoleAuthenticatedLayoutInternalLayoutTeamIndexRoute: ConsoleAuthenticatedLayoutInternalLayoutTeamIndexRoute,
};
const ConsoleAuthenticatedLayoutInternalLayoutRouteWithChildren = ConsoleAuthenticatedLayoutInternalLayoutRoute._addFileChildren(ConsoleAuthenticatedLayoutInternalLayoutRouteChildren);
const ConsoleAuthenticatedLayoutProfileLayoutRouteChildren = {
    ConsoleAuthenticatedLayoutProfileLayoutIndexRoute: ConsoleAuthenticatedLayoutProfileLayoutIndexRoute,
    ConsoleAuthenticatedLayoutProfileLayoutConnectionsIndexRoute: ConsoleAuthenticatedLayoutProfileLayoutConnectionsIndexRoute,
    ConsoleAuthenticatedLayoutProfileLayoutSecurityIndexRoute: ConsoleAuthenticatedLayoutProfileLayoutSecurityIndexRoute,
};
const ConsoleAuthenticatedLayoutProfileLayoutRouteWithChildren = ConsoleAuthenticatedLayoutProfileLayoutRoute._addFileChildren(ConsoleAuthenticatedLayoutProfileLayoutRouteChildren);
const ConsoleAuthenticatedLayoutWorkspaceLayoutRouteChildren = {
    ConsoleAuthenticatedLayoutWorkspaceLayoutBillingRoute: ConsoleAuthenticatedLayoutWorkspaceLayoutBillingRoute,
    ConsoleAuthenticatedLayoutWorkspaceLayoutIndexRoute: ConsoleAuthenticatedLayoutWorkspaceLayoutIndexRoute,
};
const ConsoleAuthenticatedLayoutWorkspaceLayoutRouteWithChildren = ConsoleAuthenticatedLayoutWorkspaceLayoutRoute._addFileChildren(ConsoleAuthenticatedLayoutWorkspaceLayoutRouteChildren);
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRouteChildren = {
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutDestinationsIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutDestinationsIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksByDestinationIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksByDestinationIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutSmartLinksIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutThemesIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutThemesIndexRoute,
};
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRouteWithChildren = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute._addFileChildren(ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRouteChildren);
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRouteChildren = {
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAbTestingLayoutRouteWithChildren,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAnalyticsIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutAnalyticsIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutCustomizeIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutCustomizeIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutFeedbackIndexRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutFeedbackIndexRoute,
};
const ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRouteWithChildren = ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute._addFileChildren(ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRouteChildren);
const ConsoleAuthenticatedLayoutRouteChildren = {
    ConsoleAuthenticatedLayoutIndexRoute: ConsoleAuthenticatedLayoutIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsNewRoute: ConsoleAuthenticatedLayoutCampaignsNewRoute,
    ConsoleAuthenticatedLayoutInternalLayoutRoute: ConsoleAuthenticatedLayoutInternalLayoutRouteWithChildren,
    ConsoleAuthenticatedLayoutProfileLayoutRoute: ConsoleAuthenticatedLayoutProfileLayoutRouteWithChildren,
    ConsoleAuthenticatedLayoutWorkspaceLayoutRoute: ConsoleAuthenticatedLayoutWorkspaceLayoutRouteWithChildren,
    ConsoleAuthenticatedLayoutCampaignsIndexRoute: ConsoleAuthenticatedLayoutCampaignsIndexRoute,
    ConsoleAuthenticatedLayoutOnboardingIndexRoute: ConsoleAuthenticatedLayoutOnboardingIndexRoute,
    ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRoute: ConsoleAuthenticatedLayoutCampaignsPublicIdLayoutRouteWithChildren,
};
const ConsoleAuthenticatedLayoutRouteWithChildren = ConsoleAuthenticatedLayoutRoute._addFileChildren(ConsoleAuthenticatedLayoutRouteChildren);
const ConsoleAuthenticatedRouteChildren = {
    ConsoleAuthenticatedLayoutRoute: ConsoleAuthenticatedLayoutRouteWithChildren,
};
const ConsoleAuthenticatedRouteWithChildren = ConsoleAuthenticatedRoute._addFileChildren(ConsoleAuthenticatedRouteChildren);
const rootRouteChildren = {
    LayoutRoute: LayoutRouteWithChildren,
    ConsoleAuthenticatedRoute: ConsoleAuthenticatedRouteWithChildren,
    AuthCallbackIndexRoute: AuthCallbackIndexRoute,
    AuthLinkConsumesTokenRoute: AuthLinkConsumesTokenRoute,
};
export const routeTree = rootRouteImport
    ._addFileChildren(rootRouteChildren)
    ._addFileTypes();
